import { useIntl } from 'react-intl';

export const AdminPagination = ({
  page,
  totalCount,
  limit,
  onPageChange,
  disabled = false,
}: {
  page: number;
  totalCount: number;
  limit: number;
  onPageChange: (page: number) => void;
  disabled?: boolean;
}) => {
  const intl = useIntl();
  const totalPages = Math.max(1, Math.ceil(totalCount / limit));

  return (
    <div style={{ margin: '20px 0' }}>
      <button
        onClick={() => onPageChange(Math.max(1, page - 1))}
        disabled={page <= 1 || disabled}
      >
        {intl.formatMessage({ id: 'admin.pagination.prev' })}
      </button>
      <span style={{ margin: '0 20px' }}>
        {intl.formatMessage(
          { id: 'admin.pagination.pageOf' },
          { page, totalPages }
        )}
      </span>
      <button
        onClick={() => onPageChange(page + 1)}
        disabled={page >= totalPages || disabled}
      >
        {intl.formatMessage({ id: 'admin.pagination.next' })}
      </button>
    </div>
  );
};
